import React, { useState, useEffect } from "react";
import {
    mdiHome,
    mdiChevronDoubleRight,
    mdiDelete,
    mdiCartArrowDown,
    mdiPlus,
    mdiPrinter,
    mdiCurrencyUsd,
    mdiClose,
} from "@mdi/js";
import Icon from "@mdi/react";
import NumberFormat from "react-number-format";

import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
import { convertToNumber } from "utils/currencyFormat";
import { pushNotification } from "utils/notifications";

import { formatNumber } from "utils/currencyFormat";
import { BtnSuaGia } from "./SuaGia/BtnSuaGia";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import { AutocompleteMaHang } from "./AutocompleteMaHang";
import { convertDate } from "utils/currencyFormat";
import { LamTronNghin } from "utils/utils";

export const TableSanPhamSanPhamXaGo = ({
    dataBanHang,
    isKGCXaGo,
    IsFocusTenSanPham,
    setDataBanHang,
    objDataStore,
    sCode,
    disEditDonGia,
    disEditAll,
    listNhomSP,
    setListNhomSP,
    setListChietKhauNhom,
    listChietKhauNhom,
    lamTron,
    GoiPhanMem,
    HienthiAutotrukhogiacong,
    isNhapThueGTGT,
    valueSanPham,
    setValueSanPham,
}) => {
    const [dataListXaGo, setDataListXaGo] = useState([]);
    const [idSanPham, setIdSanPham] = useState(0);
    const [indexSanPham, setindexSanPham] = useState(0);

    useEffect(() => {
        var list = laydataXaGo();
        setDataListXaGo(list);
    }, []);

    const laydataXaGo = () => {
        var list = [];
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((category, i) => {
            let kieugiacongxago = false;
            var tong = 0;
            var valueAttribute = 0;
            category.Options.map((op) => {
                if (
                    isKGCXaGo == true &&
                    op.OptionID == category.OptionID &&
                    op.Name.toLowerCase().trim().includes("xà gồ")
                ) {
                    kieugiacongxago = true;
                    category.OptionName = op.Name;
                }
            });
            if (isKGCXaGo && kieugiacongxago) {
                if (valueAttribute == 0) {
                    category.Attributes.map((Attribute, i) => {
                        if (Attribute.isCheck) {
                            valueAttribute = Attribute.Values;
                        } else if (Attribute.IsBanTTK) {
                            valueAttribute = Attribute.Values;
                        }
                    });
                }
                // bán ttk
                // End bán ttk

                category.Attributes.map((Attribute, index) => {
                    if (Attribute.Values && Attribute.isCheck && Attribute.IsBanTTK) {
                    } else {
                        if (Attribute.Values && Attribute.isCheck) {
                        }
                        if (Attribute.Values && Attribute.IsBanTTK) {
                        }
                    }
                });
                if (valueAttribute != 0) {
                    if (category.ShowQuantity || category.IsBanBuon) {
                        tong = valueAttribute * CustomerParseFloat(category.Quantity);
                    } else {
                        tong = valueAttribute;
                    }
                } else {
                    if (category.ShowQuantity || category.IsBanBuon) {
                        if (category.RateForSale !== 0) {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(category.Quantity) *
                                category.RateForSale;
                        } else {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(category.Quantity);
                        }
                    } else {
                        if (category.RateForSale !== 0) {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                category.RateForSale;
                        } else {
                            tong = CustomerParseFloat(category.ValueOfUnitForExportPrice);
                        }
                    }
                }
                tong = CustomerParseFloat(numeral(tong));
                category.Tong = tong;

                const sanpham = list.find(
                    (e) =>
                        e.CategoryID === category.CategoryID &&
                        e.OptionID === category.OptionID
                );
                if (typeof sanpham !== "undefined" && sanpham != null) {
                    var listNew = list.map((xago, i) => {
                        if (
                            xago.CategoryID == category.CategoryID &&
                            xago.OptionID === category.OptionID
                        ) {
                            xago.Tong = xago.Tong + category.Tong;
                            var lamTron = CustomerParseFloat(numeral(xago.Tong));
                            xago.Tong = lamTron;
                        }

                        return xago;
                    });

                    list = listNew;
                } else {
                    list.push(category);
                }
            }
            return category;
        });
        // setDataListXaGo(list);
        return list;
    };

    // Số lượng
    const onChangeText = (field, e, index) => updateDanhSach(field, e, index);
    const updateDanhSach = (field, e, index) => {
        const obj = { ...dataBanHang };

        var listxaGo = laydataXaGo();
        var lstNew = listxaGo.map((cate, i) => {
            if (index === i) {
                var value = numeral(
                    e.target.validity.valid ? e.target.value : cate[field]
                )
                    .format("0.[0000]")
                    .doidau();
                setindexSanPham(index);
                setIdSanPham(cate.CategoryID);
                setValueSanPham(CustomerParseFloat(value));

                if (value <= 0) {
                    pushNotification(
                        "Số lượng phải lớn hơn 0",
                        "error",
                        "TOP_RIGHT",
                        3000
                    );
                } else {
                    cate.Tong = value;
                    var TongSoLuongNhanKichThuoc = 0;

                    obj.lstChiTiet.map((category, i) => {
                        if (cate.CategoryID == category.CategoryID) {
                            var valueAttribute = 0;
                            var tong = 0;
                            let kieugiacongxago = false;
                            category.Options.map((op) => {
                                if (
                                    isKGCXaGo == true &&
                                    op.OptionID == category.OptionID &&
                                    op.Name.toLowerCase().trim().includes("xà gồ")
                                ) {
                                    kieugiacongxago = true;
                                    category.OptionName = op.Name;
                                }
                            });
                            if (isKGCXaGo && kieugiacongxago) {
                                TongSoLuongNhanKichThuoc =
                                    TongSoLuongNhanKichThuoc +
                                    CustomerParseFloat(category.Quantity) *
                                    CustomerParseFloat(category.SLDonViBan);
                            }
                        }
                        return category;
                    });

                    var lstNew = obj.lstChiTiet.map((category, i) => {
                        if (cate.CategoryID == category.CategoryID) {
                            var valueAttribute = 0;
                            var tong = 0;
                            let kieugiacongxago = false;
                            category.Options.map((op) => {
                                if (
                                    isKGCXaGo == true &&
                                    op.OptionID == category.OptionID &&
                                    op.Name.toLowerCase().trim().includes("xà gồ")
                                ) {
                                    kieugiacongxago = true;
                                    category.OptionName = op.Name;
                                }
                            });
                            if (isKGCXaGo && kieugiacongxago) {
                                category.RateForSale =
                                    CustomerParseFloat(value) / TongSoLuongNhanKichThuoc;
                            }
                        }
                        return category;
                    });
                    obj.lstChiTiet = lstNew;
                    setDataBanHang(obj);
                }
            }
            return cate;
        });
    };

    const listItem = () => {
        var listxaGo = laydataXaGo();
        return (
            listxaGo != null &&
            listxaGo.map((category, index) => {
                if (
                    indexSanPham == index &&
                    category.CategoryID == idSanPham &&
                    valueSanPham > 0
                ) {
                    category.Tong = valueSanPham;
                }
                return (
                    <>
                        <div class="form-group form-ck-nhom">
                            <label class=" col-form-label">
                                {category.CategoryName}
                                {category.OptionID > 0 && (
                                    <>
                                        <div style={{ display: "inline" }}>
                                            ({category.OptionName})
                                        </div>
                                    </>
                                )}
                                {"  =  "}
                            </label>
                            <div class="form-right-ck">
                                <NumberFormat
                                    class="form-control text-right"
                                    pattern="[0-9,.]*"
                                    value={category.Tong}
                                    thousandSeparator={true}
                                    onChange={(e) => onChangeText("Tong", e, index)}
                                />
                                <span></span>
                            </div>
                        </div>
                    </>
                );
            })
        );
    };
    return (
        <>
            <div class="table-Main-content table-dateitme">
                <div class="col-sm-12">
                    <div class="form-group form-ck-nhom">
                        <label class="col-form-label">Tổng khỗi lượng</label>
                    </div>
                    {listItem()}
                </div>
            </div>
        </>
    );
};
